export default "__VITE_ASSET__116afd55__"